import React, { useState } from 'react';
import { TaskProvider } from '../contexts/TaskContext';
import { useAuth } from '../contexts/AuthContext';
import Navbar from './Navbar';
import KanbanBoard from './KanbanBoard';
import Reports from './Reports';
import AdminView from './AdminView';
import ManagerView from './ManagerView';
import LeaveManagement from './LeaveManagement';
import { FiBarChart2, FiGrid, FiUsers, FiGitBranch, FiFileText } from 'react-icons/fi';
import '../styles/Dashboard.css';

const Dashboard = () => {
  const { user } = useAuth();
  const [activeView, setActiveView] = useState('board');
  const isAdmin = user?.role === 'admin' || user?.role === 'hr';
  const isManager = user?.role === 'manager';
  const canManageLeaves = isAdmin || isManager;

  const renderContent = () => {
    switch (activeView) {
      case 'board': return <KanbanBoard />;
      case 'reports': return <Reports />;
      case 'team': return <ManagerView />;
      case 'admin': return <AdminView />;
      case 'leaves': return <LeaveManagement />;
      default: return <KanbanBoard />;
    }
  };

  return (
    <TaskProvider>
      <div className="dashboard">
        <Navbar />
        <div className="dashboard-nav">
          <button
            className={activeView === 'board' ? 'active' : ''}
            onClick={() => setActiveView('board')}
          >
            <FiGrid /> Task Board
          </button>
          <button
            className={activeView === 'reports' ? 'active' : ''}
            onClick={() => setActiveView('reports')}
          >
            <FiBarChart2 /> Reports & Analytics
          </button>
          {(isManager || isAdmin) && (
            <button
              className={activeView === 'team' ? 'active' : ''}
              onClick={() => setActiveView('team')}
            >
              <FiGitBranch /> My Team
            </button>
          )}
          {isAdmin && (
            <button
              className={activeView === 'admin' ? 'active' : ''}
              onClick={() => setActiveView('admin')}
            >
              <FiUsers /> Organization
            </button>
          )}
          {canManageLeaves && (
            <button
              className={activeView === 'leaves' ? 'active' : ''}
              onClick={() => setActiveView('leaves')}
            >
              <FiFileText /> Leaves
            </button>
          )}
        </div>
        <main className="dashboard-content">
          {renderContent()}
        </main>
      </div>
    </TaskProvider>
  );
};

export default Dashboard;

